import Nullstack from 'nullstack';
export default function IconArrowsDiff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-diff",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 16h10"
  }), "   ", Nullstack.element("path", {
    d: "M11 16l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M11 16l4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M13 8h-10"
  }), "   ", Nullstack.element("path", {
    d: "M13 8l-4 4"
  }), "   ", Nullstack.element("path", {
    d: "M13 8l-4 -4"
  }), " ");
}